'use client';
import React from 'react';
import { IoClose, IoStatsChartOutline } from 'react-icons/io5';
import { HiOutlineSearch } from 'react-icons/hi';
import { IoIosHelpCircle, IoMdListBox } from 'react-icons/io';
import Link from 'next/link';
import Image from 'next/image';
import { RiLock2Fill } from 'react-icons/ri';
import { TbLogout } from 'react-icons/tb';
import { imageData } from '@/config/defaultBlur';
import { FaRegUser, FaStar } from 'react-icons/fa6';
import { MdMailOutline } from 'react-icons/md';
import { FiCreditCard, FiTool } from 'react-icons/fi';
import { GrCurrency } from 'react-icons/gr';

interface UserRole {
  parent: {
    id: number;
    firstname: string;
    lastname: string;
  };
  role: {
    id: number;
    name: string;
  };
}
interface MobileMenuComponentProps {
  openMobileMenu: () => void;
  clickOnLink: () => void;
  userProfile?: {
    issubadmin: boolean;
    isadmin: boolean;
    ispro: boolean;
    profilepicture?: {
      text: string;
      small?: string;
    };
  } | null;
  userRoles: UserRole[] | null;
}

interface MenuItem {
  href: string;
  label: string;
}
interface TopMenuItems {
  href: string;
  label: string;
  icon: React.ReactNode;
}

const buttonItems = [
  {
    href: `/findasignup`,
    icon: <HiOutlineSearch />,
  },
  {
    href: `https://support.signupgenius.com/`,
    icon: <IoIosHelpCircle />,
  },
];

const handleLogout = () => {
  // Clear role-related items from localStorage
  localStorage.removeItem('userRoles');
  localStorage.removeItem('userRolesCacheTime');
};

export default function MobileMenuComponent({
  openMobileMenu,
  clickOnLink,
  userProfile,
  userRoles,
}: MobileMenuComponentProps) {
  const menuItems: MenuItem[] = [
    { href: `/features`, label: 'Features' },
    { href: `/pricing`, label: 'Pricing' },
    ...(!userProfile
      ? [
          {
            href: `/collect-money`,
            label: 'Collect Money',
          },
        ]
      : []),
    {
      href: `/resources`,
      label: 'Resources & Tips',
    },
    { href: `/blog`, label: 'Blog' },
    {
      href: `/enterprise`,
      label: 'Enterprise',
    },
  ];
  const topMenuItems: TopMenuItems[] = [
    {
      href: `/index.cfm?go=c.myaccount#/`,
      label: 'Sign Ups',
      icon: <IoMdListBox />,
    },
    {
      href: `/index.cfm?go=t.mygroups#/`,
      label: 'Groups',
      icon: <FaRegUser />,
    },
    {
      href: `/index.cfm?go=t.messageCenter`,
      label: 'Messages',
      icon: <MdMailOutline />,
    },
    {
      href: `/index.cfm?go=t.reports&memberid=182192759`,
      label: 'Reports',
      icon: <IoStatsChartOutline />,
    },
    {
      href: `/index.cfm?go=t.protools`,
      label: 'Tools',
      icon: <FiTool />,
    },
    {
      href: `/index.cfm?go=o.PGActivation`,
      label: 'Collect',
      icon: <GrCurrency />,
    },
    {
      href: `/index.cfm?go=o.mypurchases`,
      label: 'Billing',
      icon: <FiCreditCard />,
    },
    ...(userProfile?.ispro == false
      ? [
          {
            href: `/index.cfm?go=o.ProGeniusProducts&showtrial=1`,
            label: 'Free Premium Trial',
            icon: <FaStar />,
          },
        ]
      : []),
  ];
  return (
    <>
      <div className="mobileHeaderMenuWrap">
        {userProfile && (
          <ul className="mobileHeaderMenuList mobileMenuIconList">
            {topMenuItems.map((item, index) => (
              <li
                key={index}
                className="mobileHeaderMenu"
                onClick={clickOnLink}
              >
                <Link className="mobileHeaderMenuLink" href={item.href}>
                  {item.icon} <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
        <ul className="mobileHeaderMenuList">
          {menuItems.map((item, index) => (
            <li key={index} className="mobileHeaderMenu" onClick={clickOnLink}>
              <Link className="mobileHeaderMenuLink" href={item.href}>
                {item.label}
              </Link>
            </li>
          ))}
          {!userProfile && (
            <li className="mobileHeaderMenu" onClick={clickOnLink}>
              <Link className="mobileHeaderMenuLink" href={`/register`}>
                Log In
              </Link>
            </li>
          )}
          {userProfile && (userRoles?.length ?? 0) > 0 && (
            <li className="mobileHeaderMenu" onClick={clickOnLink}>
              <Link
                onClick={clickOnLink}
                className="mobileHeaderMenuLink"
                href={`/MyAccount/ResetAdminID/1?switch=true`}
              >
                Switch Account
              </Link>
            </li>
          )}
        </ul>
      </div>
      <div className="mobileHeaderSidebar">
        <div className="closeMenu" onClick={openMobileMenu}>
          <IoClose />
        </div>

        {userProfile?.profilepicture?.text ? (
          <Link
            className="profile-name"
            href="/index.cfm?go=m.editprofile&memberid=182192759"
          >
            {userProfile.profilepicture.text}
          </Link>
        ) : userProfile?.profilepicture?.small ? (
          <Image
            src={userProfile?.profilepicture?.small || ''}
            alt="profile"
            height={34}
            width={34}
            className="profile-img"
            placeholder="blur"
            blurDataURL={imageData.blurImage}
          />
        ) : null}
        <div className="btnWrap" onClick={clickOnLink}>
          {buttonItems.map((item, index) => (
            <Link
              key={index}
              className="searchLink"
              href={item.href}
              target="_blank"
            >
              {item.icon}
            </Link>
          ))}
          {userProfile && (
            <Link
              className="searchLink"
              href={`/index.cfm?go=c.logout`}
              onClick={handleLogout}
            >
              <TbLogout />
            </Link>
          )}
          {userProfile && userProfile.isadmin == true && (
            <Link className="searchLink" href={`/admin`}>
              <RiLock2Fill />
            </Link>
          )}
        </div>
      </div>
    </>
  );
}
